<route>
{
  "meta": {
    "permission": [
      "purchase.view_purchaseorder"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <v-row row wrap>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="code"
          :name="$t('code')"
          rules=""
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.code"
            outlined
            :error-messages="errors[0]"
            :label="$t('code')"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="name"
          :name="$t('name')"
          rules=""
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.name"
            outlined
            :error-messages="errors[0]"
            :label="$t('name')"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" sm="3">
        <ValidationProvider
          vid="status"
          :name="$t('status')"
          rules=""
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="form.status"
            outlined
            :error-messages="errors[0]"
            :label="$t('status')"
            class="secondary--text"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <i-table
      :title="$tc('purchasesReport', 2)"
      :headers="headers"
      app="purchase.purchaseorder"
      api="purchase.product"
      :opt="{
        code: this.form.code,
        name: this.form.name,
        status: this.form.status
      }"
      dontCreate
      dontRemove
      dontEdit
      dontSearch
    >
      <template v-slot:extraToolbar>
        <v-divider class="mx-4" inset vertical></v-divider>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-excel"
          :title="$t('download', { value: $t('purchasesReport') })"
          color="text-dark"
          @click="getPurchaseOrdersExcel()"
        >
        </i-btn>
        <i-btn
          text
          :small="$vuetify.breakpoint.smAndDown"
          icon="fa-file-pdf"
          :title="$t('download', { value: $t('purchasesReport') })"
          color="text-dark"
          @click="getPurchaseOrdersPDF()"
        >
        </i-btn>
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        name: '',
        code: '',
        status: ''
      }
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('order_code'),
          value: 'code'
        },
        {
          text: this.$t('order_name'),
          value: 'projectName'
        },
        {
          text: this.$t('order_status'),
          value: 'orderMain'
        },
        {
          text: this.$tc('supplier', 1),
          value: 'infoSupplierName'
        },
        {
          text: this.$t('dateOrder'),
          value: 'orderDate'
        },
        {
          text: this.$t('expected_date'),
          value: 'expectedDate'
        },
        {
          text: this.$tc('purchasesReceiver', 1),
          value: 'receiverName'
        },
        {
          text: this.$tc('product', 1),
          value: 'own_prod'
        },
        {
          text: this.$tc('price', 1),
          value: 'price',
          align: 'right'
        },
        {
          text: this.$tc('quantity', 1),
          value: 'quantity',
          align: 'right'
        },
        {
          text: this.$tc('received_quantity', 1),
          value: 'received_quantity',
          align: 'right'
        },
        {
          text: this.$tc('pending_quantity', 1),
          value: 'pending_quantity',
          align: 'right'
        },
        {
          text: this.$tc('received_date', 1),
          value: 'received_date'
        },
        {
          text: this.$tc('subtotal', 1),
          value: 'subtotal',
          align: 'right'
        }
      ]
    },
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    getPurchaseOrdersExcel() {
      this.downloadFile({
        api: 'purchase.product',
        method: 'excel',
        filename: 'PurchaseOrders',
        action: 'download',
        ext: 'xlsx',
        opt: {
          pk: this.company.pk,
          params:
            '?name=' +
            this.form.name +
            '&code=' +
            this.form.code +
            '&status=' +
            this.form.status
        }
      })
    },
    getPurchaseOrdersPDF() {
      this.downloadFile({
        api: 'purchase.product',
        method: 'pdf',
        filename: 'PurchaseOrders',
        action: 'download',
        ext: 'pdf',
        opt: {
          pk: this.company.pk,
          params:
            '?name=' +
            this.form.name +
            '&code=' +
            this.form.code +
            '&status=' +
            this.form.status
        }
      })
    }
  }
}
</script>
